import { COUNTRY_CODE } from '@/utils/constants';
import type { AddressSelectedPayload } from '../types/ideal-postcodes';

type IdealPostcodesResolvedAddress = {
  line_1?: string;
  line_2?: string;
  line_3?: string;
  post_town?: string;
  postcode?: string;
  latitude?: string | number;
  longitude?: string | number;
  uprn?: string;
};

export function formatIdealPostcodesFullAddress(address: IdealPostcodesResolvedAddress): string {
  const parts = [
    address.line_1,
    address.line_2,
    address.line_3,
    address.post_town,
    address.postcode,
  ].filter((part) => typeof part === 'string' && part.trim() !== '');
  return parts.join(', ');
}

export function toAddressSelectedPayload(
  address: IdealPostcodesResolvedAddress,
  fullAddress: boolean,
): AddressSelectedPayload {
  const line1 = address.line_1 ?? '';
  const uprn = address.uprn ?? null;

  if (!fullAddress) {
    return { line1, uprn };
  }

  const lat = address.latitude;
  const lng = address.longitude;

  return {
    line1,
    uprn,
    fullAddress: formatIdealPostcodesFullAddress(address),
    postcode: address.postcode,
    latitude: lat != null ? Number(lat) : null,
    longitude: lng != null ? Number(lng) : null,
    country: COUNTRY_CODE['United Kingdom'],
  };
}

export function toManualEntryPayload(
  value: string | undefined,
  fullAddress: boolean,
): AddressSelectedPayload {
  const line1 = value ?? '';
  if (!fullAddress) {
    return { line1, uprn: null };
  }

  return {
    line1,
    uprn: null,
    fullAddress: line1,
    postcode: undefined,
    latitude: null,
    longitude: null,
    country: undefined,
  };
}
